require('./../css/style.css');

function toggleQuestion() {
    const fqaPanels = document.querySelectorAll(".js-faq-panel-item");
    const fqaPanelsArray = Array.from(fqaPanels);

    fqaPanelsArray.forEach((element) => {
        const panelHeader = element.querySelector(".js-faq-header");
        const panelText = element.querySelector(".js-faq-rte");
        const panelDesc = element.querySelector(".js-faq-rte-holder");
        const panelDescHeight = panelDesc.offsetHeight;

        panelHeader.addEventListener("click", () => {
            element.classList.toggle("_show");
            if (element.classList.contains("_show")) {
                panelText.style.maxHeight = panelDescHeight + "px";
            } else {
                panelText.style.maxHeight = "0";
            }
        });
    });
}

export default toggleQuestion


// WEBPACK FOOTER //
// ./uPortal/Core/Panels/FaqPanel/Js/index.js